import React, { useState } from "react";
import { SEC_DataApiPost } from "../../func.js";
import "./NoteInputComponent.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RiSave3Fill } from "react-icons/ri";
import { CgSpinner } from "react-icons/cg";
import useS3FileUpload from "../../hooks/useS3FileUpload";
import { userAppData } from "../../MainApp";
import { FileDropzone } from "../formComponents.js";
import { FiPaperclip } from "react-icons/fi";

export function NoteInputComponent({
  requestId,
  url,
  updateApiCallFunction,
  placeholder,
  cardView = false,
  showPrivateToggle = false,
  uploadModuleType = "itRequests",
  permissionsKey = "itRequestsData"
}) {
  const [note, setNote] = useState("");
  const [privateNote, setPrivateNote] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [postApiErrorState, setPostApiErrorState] = useState(false);
  const [files, setFiles] = useState([]);
  const [showDropzone, setShowDropzone] = useState(false);
  const { uploadFiles } = useS3FileUpload(uploadModuleType);
  const canManageRequests = !!userAppData?.[permissionsKey]?.allowManageRequests;
  const showPrivateNoteToggle = showPrivateToggle && canManageRequests;

  async function addNote() {
    if (!note.trim()) {
      toast.warn("⚠️ Please enter a note before submitting.", { autoClose: 3000, position: "top-right" });
      return;
    }

    if (isLoading) return;
    setIsLoading(true);
    setPostApiErrorState(false);

    try {
      let uploadedFiles = [];
      const validFiles = files.filter(f => f && f.file && typeof f.fileName === 'string');
      if (validFiles.length > 0) {
        const filesToUpload = validFiles.map(f => ({
          fileName: f.fileName,
          fileSize: f.fileSize,
          file: f.file,
        }));
        uploadedFiles = await uploadFiles(filesToUpload, userAppData.cogId, { requestId });
      }

      const formData = {
        requestId,
        note,
        privateNote,
        files: uploadedFiles,
      };

      console.log(formData)

      const response = await SEC_DataApiPost(url, JSON.stringify(formData), {}, () => setPostApiErrorState(true));

      if (response && response.ResponseMetadata?.HTTPStatusCode === 200) {
        toast.success("✅ Request Updated!", { autoClose: 3000, position: "top-right" });
        updateApiCallFunction(requestId);
        setNote("");
        setPrivateNote(false);
        setFiles([]);
        setShowDropzone(false);
      } else {
        toast.error("❌ Failed to update request. Please try again.", { autoClose: 3000, position: "top-right" });
      }
    } catch (error) {
      console.error("Error adding note", error);
      toast.error("❌ Failed to update request. Please try again.", { autoClose: 3000, position: "top-right" });
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className={`note-input-container${cardView ? ' note-input-container-card' : ''}`}>
      <div className={`note-inputandSave-container${cardView ? ' note-inputandSave-container-card' : ''}`}>
        <div className="note-text-block">
          <textarea
            className="note-input-text-area"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder={placeholder}
            disabled={isLoading}
          />

          {showPrivateNoteToggle && (
            <div className="note-private-toggle-row">
              <span className="note-private-toggle-label">Private note</span>
              <label className="note-private-switch" aria-label="Private note toggle">
                <input
                  type="checkbox"
                  checked={privateNote}
                  onChange={(e) => setPrivateNote(e.target.checked)}
                  disabled={isLoading}
                />
                <span className="note-private-slider" />
              </label>
            </div>
          )}
        </div>

        <div className={`note-input-actions${cardView ? ' note-input-actions-card' : ''}`}>
          <button onClick={() => setShowDropzone(!showDropzone)} disabled={isLoading} className="note-toggle-attachments-button">
              <FiPaperclip className="note-save-icon" color="white" />
          </button>

          <button onClick={addNote} disabled={isLoading} className="note-save-button">
            {isLoading ? (
              <span className="note-save-button-spinner">
                <CgSpinner color="white" />
              </span>
            ) : (
              <RiSave3Fill className="note-save-icon" color="white" />
            )}
          </button>
        </div>

      </div>

      {showDropzone && (
        <div className="note-dropzone-wrapper">
          <FileDropzone
            filesState={files}
            fileStateSet={setFiles}
            disabled={isLoading}
            maxFiles={10}
            maxTotalSizeMB={50}
            fullWidth
          />
        </div>
      )}
    </div>
  );
}
